import { useState } from 'react';
import type { Message, MessageBodyType } from '@/types/messages.ts';

export interface MessageUnfolding {
  /** The words to draw: as they were first written, when the reader asked for those. */
  body: MessageBodyType;
  showingOriginal: boolean;
  toggleOriginal: () => void;
  /** The agent's reasoning summaries; null when the turn ran without them. */
  reasoning: string[] | null;
  /** Whether the reasoning is unfolded; undefined when there is none to unfold. */
  reasoningOpen: boolean | undefined;
  toggleReasoning: (() => void) | undefined;
}

/** What the reader opened up on one message: its original words, the agent's reasoning. */
export function useMessageUnfolding(message: Message): MessageUnfolding {
  const [showingOriginal, setShowingOriginal] = useState(false);
  const [reasoningOpen, setReasoningOpen] = useState(false);

  const body =
    showingOriginal && message.meta?.original_body
      ? message.meta.original_body
      : message.body;
  const reasoning = message.reasoning?.length ? message.reasoning : null;

  return {
    body,
    showingOriginal,
    toggleOriginal: () => setShowingOriginal((shown) => !shown),
    reasoning,
    reasoningOpen: reasoning ? reasoningOpen : undefined,
    toggleReasoning: reasoning ? () => setReasoningOpen((open) => !open) : undefined,
  };
}
